import React, { useState, useEffect } from "react";

import Axios from "axios";

import { MDBBtn, MDBTable, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter, } from "mdb-react-ui-kit";
import {useParams, useNavigate, Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";

import Moment from 'moment';
import {backendPathAuth, backendPathTasks} from "../Constants";
import TopNavbar from "../components/Navbar";
import {loadPermissions} from "../functions/permissions";


function Task() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [firstNameC, setFirstNameC] = useState("");
    const [lastNameC, setLastNameC] = useState("");
    const [firstNameE, setFirstNameE] = useState("");
    const [lastNameE, setLastNameE] = useState("");
    const [annotation, setAnnotation] = useState("");
    const [customerID, setCustomerID] = useState(0);
    const [employeeID, setEmployeeID] = useState(0);

    const [deletionPopupVisible, setDeletionPopupVisible] = useState(false);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);


    const getTask = () => {
        Axios.get(`${backendPathTasks}task.php?id=${id}`).then((response) => {
            console.log(response.data);
            const task = response.data[0];
            setStartDate(task.StartDate);
            setEndDate(task.EndDate);
            setFirstNameC(task.FirstNameC);
            setLastNameC(task.LastNameC);
            setFirstNameE(task.FirstNameE);
            setLastNameE(task.LastNameE);
            setAnnotation(task.Annotation);
            setEmployeeID(task.EmployeeID);
            setCustomerID(task.CustomerID);
        });
    };

    const toggleShow = () => setDeletionPopupVisible(!deletionPopupVisible);

    const deleteTask = () => {
        Axios.delete(`${backendPathTasks}delete-task.php?id=${id}`).then((response) => {
            navigate("/",);
        });

    };

    const editTask = () => {
        navigate("/edit-task/" + id,);
    };

    useEffect(() => {
        console.log("effect 0");
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);

    useEffect(() => {
        getTask();
    }, [id]);

    return (
        <>
        <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>

        <div className='main'>
            <div className='header'>
                <h2>Einsatz</h2>
                <div className='btns'>
                    <MDBBtn className="btn delete" onClick={toggleShow}>
                        <FontAwesomeIcon className='btn-icon' icon={faTrash} />
                        Löschen
                    </MDBBtn>
                    <MDBBtn className="btn" onClick={editTask}>
                        <FontAwesomeIcon className='btn-icon' icon={faPen} />
                        Bearbeiten
                    </MDBBtn>
                </div>
            </div>

            <MDBTable align='middle'>
                <tbody>
                <tr>
                    <th>Startdatum</th>
                    <td>{Moment(startDate).format("DD.MM.YYYY")}</td>
                </tr>
                <tr>
                    <th>Enddatum</th>
                    <td>{Moment(endDate).format("DD.MM.YYYY")}</td>
                </tr>
                <tr>
                    <th>Kunde/in</th>
                    <td><Link to={"/customer/"+customerID}>{firstNameC} {lastNameC}</Link></td>
                </tr>
                <tr>
                    <th>Betreuer/in</th>
                    <td>{ employeeID === -1 ? '-' :
                        <Link to={"/employee/"+employeeID}>{firstNameE} {lastNameE}</Link>
                    }</td>
                </tr>
                <tr>
                    <th>Notizen</th>
                    <td>{annotation? annotation : '-'}</td>
                </tr>
                </tbody>
            </MDBTable>

            <MDBModal show={deletionPopupVisible} setShow={setDeletionPopupVisible} tabIndex="-1">
                <MDBModalDialog>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Einsatz löschen</MDBModalTitle>
                            <MDBBtn
                                className="btn-close"
                                color="none"
                                onClick={toggleShow}
                            ></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>Soll der Einsatz wirklich gelöscht werden?</MDBModalBody>

                        <MDBModalFooter>
                            <MDBBtn className="btn-light" onClick={toggleShow}>
                                Abbrechen
                            </MDBBtn>
                            <MDBBtn onClick={deleteTask}>Löschen</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

        </div>
        </>
    );
}

export default Task;